"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getSizeProps = exports.anchorOpenDirection = exports.DatePickerOpenDirection = exports.DatePickerSize = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDates = require("react-dates");

var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _moment = _interopRequireDefault(require("moment"));

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Theme
const DatePickerSize = {
  sm: 'sm',
  md: 'md'
};
exports.DatePickerSize = DatePickerSize;
const DatePickerOpenDirection = {
  down: 'OPEN_DOWN',
  up: 'OPEN_UP'
};
exports.DatePickerOpenDirection = DatePickerOpenDirection;
const anchorOpenDirection = {
  left: 'left',
  right: 'right'
};
exports.anchorOpenDirection = anchorOpenDirection;

const StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "DatePicker__StyledWrapper",
  componentId: "design-system__ldbob-0"
})([".DateInput_fang{bottom:-10px;left:calc(100% + 5.5px);}.SingleDatePicker_picker{margin-top:15px;}.SingleDatePickerInput_clearDate_svg{width:10px;height:10px;}.SingleDatePickerInput{border-radius:", ";border-color:", ";& .DateInput{width:6rem;}& input.DateInput_input{color:", ";font-family:", ";font-size:1rem;font-weight:", ";box-sizing:border-box;height:38px;padding:12px 11px 8px;outline:none;}}.SingleDatePickerInput_clearDate{padding:", ";line-height:inherit;border-radius:10px;top:45%;transform:translateY(-45%);cursor:pointer;right:5px;height:calc(100% - 10px);display:flex;align-items:center;margin:0;}"], _BaseTheme.default.radius.regular, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.weight.regular, _ref => {
  let {
    size
  } = _ref;
  return size === DatePickerSize.sm ? '0px 8px' : '3px 8px';
});

const getSizeProps = function getSizeProps() {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DatePickerSize.md;
  return {
    small: size === DatePickerSize.sm,
    regular: size === DatePickerSize.md
  };
};

exports.getSizeProps = getSizeProps;

const DatePicker = _ref2 => {
  let {
    date,
    id,
    onDateChange,
    showClearDate,
    placeholder,
    openDirection,
    anchorDirection,
    onClose,
    displayFormat,
    isOutsideRange,
    size,
    numberOfMonths
  } = _ref2;
  const [focused, setFocused] = (0, _react.useState)(false);
  const {
    small,
    regular
  } = getSizeProps(size);

  const onFocusChange = () => {
    setFocused(!focused);
  };

  const internalOnClose = _ref3 => {
    let {
      date: selectedDate
    } = _ref3;
    return onClose && onClose({
      date: selectedDate
    });
  };

  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_reactDates.SingleDatePicker, {
    date: date ? (0, _moment.default)(date) : date,
    id: id,
    focused: focused,
    onDateChange: onDateChange,
    onFocusChange: onFocusChange,
    showClearDate: showClearDate,
    placeholder: placeholder,
    openDirection: openDirection,
    anchorDirection: anchorDirection,
    onClose: internalOnClose,
    small: small,
    regular: regular,
    displayFormat: displayFormat,
    isOutsideRange: isOutsideRange,
    numberOfMonths: numberOfMonths
  }));
};

DatePicker.propTypes = {
  date: _propTypes.default.oneOfType([_reactMomentProptypes.default.momentObj, _propTypes.default.string]),
  onDateChange: _propTypes.default.func.isRequired,
  id: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  showClearDate: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  displayFormat: _propTypes.default.string,
  openDirection: _propTypes.default.oneOf([DatePickerOpenDirection.up, DatePickerOpenDirection.down]),
  anchorDirection: _propTypes.default.oneOf([anchorOpenDirection.left, anchorOpenDirection.right]),
  isOutsideRange: _propTypes.default.func,
  size: _propTypes.default.oneOf([DatePickerSize.sm, DatePickerSize.md]),
  numberOfMonths: _propTypes.default.number
};
DatePicker.defaultProps = {
  date: null,
  // eslint-disable-next-line no-unused-vars
  isOutsideRange: date => false,
  openDirection: null,
  anchorDirection: anchorOpenDirection.left,
  displayFormat: 'yyyy-MM-DD',
  onClose: null,
  showClearDate: false,
  placeholder: '',
  size: DatePickerSize.md,
  numberOfMonths: 1
};
var _default = DatePicker;
exports.default = _default;